import VendorHero from './Components/VendorHero';
import VendorPromises from './Components/VendorPromises';
import VendorProcess from './Components/VendorProcess';
import VendorTrack from './Components/VendorTrack';
import VendorLegal from './Components/VendorLegal';
import VendorFAQs from './Components/VendorFAQs';
const VendorHome = () => {
    
    return (
        <div className="w-full flex flex-col">
            <VendorHero />
            <VendorPromises />
            <VendorProcess />
            <VendorTrack />
            <VendorFAQs />
            <div className="w-full flex bg-charmPurple ">
                <VendorLegal />
            </div>
        </div>
    );
}

export default VendorHome;